import {useEffect, useState} from 'react';
import moment from 'moment';


export const DateTime = (props) => {
    const [dateTime, setDateTime] = useState(Date.now)

    useEffect(() => {
        const id = setInterval(() => setDateTime(Date.now()));
        return () => {
            clearInterval(id);
        }
    }, []);

    const timeOffsetAdjustedDate = dateTime - props.timeOffset;
    const timeAndZoneOffsetAdjustedDate = props.timeZoneOffset
        ? moment(timeOffsetAdjustedDate).zone(props.timeZoneOffset)
        : moment(timeOffsetAdjustedDate)
    return moment(timeAndZoneOffsetAdjustedDate).format(props.showHeaderDateFormat);
}
  




// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/components/dateTime.js